var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.496 1-.317 1.025v29.748l.317.302 14.496-8.163L23.495 1Z",
    fill: "#62688F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.496 1 9 23.912l14.496 8.163V1Z",
    fill: "#8A92B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.496 34.69-.179.206v10.597l.179.497L38 26.53l-14.504 8.16Z",
    fill: "#62688F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.496 45.99V34.689L9 26.531 23.496 45.99Z",
    fill: "#8A92B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.496 32.075 14.495-8.163-14.495-6.276v14.439Z",
    fill: "#454A75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m9 23.912 14.495 8.163v-14.44L9 23.913Z",
    fill: "#62688F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.a46d4006e811f11bc5a70ff0fd148346.svg";
export { ForwardRef as ReactComponent };